import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ConfirmModalStyleParts = [
  'bodyContainer',
  'icon',
  'headerText',
  'bodyText',
  'footerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(ConfirmModalStyleParts)

export const ConfirmModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      alignItems: 'flex-start',
    },
    icon: {
      boxSize: '2rem',
      paddingBottom: '0.5rem',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    bodyText: {
      ...textStyles[textStyleKeys.Body1],
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.625rem',
    },
  },
})

export const useConfirmModalStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ConfirmModalStyle, props) as MultiStyleType<
    typeof ConfirmModalStyleParts
  >
}
